import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const ThumbsUpIcon: React.FC<Props> = props => {
  const size = props.size || 26;
  const color = props.color || '#999999';
  return <Icon name={'project-thumbs-up'} size={size} color={color} />;
};

export default React.memo(ThumbsUpIcon);
